import { ChangeEvent, memo } from 'react';
import styled, { css } from 'styled-components';
import theme from '@styles/theme';

type StyledCheckboxProps = {
    SQUARE?: boolean;
    id?: string;
    label?: string;
    margin?: string;
    gap?: number;
    width?: string;
    fontColor?: string;
    checkboxId: string;
    value: any;
    name: string;
    checked: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const StyledCheckbox = ({
    SQUARE = false,
    id,
    label,
    margin,
    gap,
    width,
    fontColor,
    checkboxId,
    value,
    name = 'checkbox',
    checked,
    onChange = () => null
}: StyledCheckboxProps) => {
    return (
        <Wrapper id={id} $margin={margin} $width={width}>
            <Box $gap={gap}>
                <Input
                    id={checkboxId}
                    type="checkbox"
                    name={name}
                    value={value}
                    onChange={onChange}
                    checked={checked}
                />
                <Label
                    htmlFor={checkboxId}
                    $checked={checked}
                    $fontColor={fontColor}
                    $square={SQUARE}
                    $gap={gap}
                >
                    {label}
                </Label>
            </Box>
        </Wrapper>
    );
};

export default memo(StyledCheckbox);

const Wrapper = styled.div<{ $margin?: string; $width?: string }>`
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
    width: ${({ $width }) => ($width ? $width : 'auto')};
`;
const Box = styled.div<{ $gap?: number }>`
    position: relative;
    display: flex;
    align-items: center;
    margin-left: ${({ $gap }) => ($gap ? 26 - $gap : 26)}px;
`;
const Label = styled.label<{
    $margin?: string;
    $checked?: boolean;
    $fontColor?: string;
    $square?: boolean;
    $gap?: number;
}>`
    font-size: 14px;
    font-weight: 500;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.grayFontColor};
    /* line-height: 20px; */
    display: inline-block;
    margin-left: 4px;
    cursor: pointer;

    &:before {
        content: '';
        display: inline-block;
        top: 6px;
        left: ${({ $gap }) => ($gap ? $gap - 21 : -21)}px;
        vertical-align: top;
        -webkit-transition: -webkit-transform 0.4s
            cubic-bezier(0.45, 1.8, 0.5, 0.75);
        -moz-transition: -moz-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
        transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        transform: rotate(-45deg);
        z-index: 1;
        width: 8px;
        height: 3px;
        border-top-style: none;
        border-right-style: none;
        border-width: 2px;
        position: absolute;
        cursor: pointer;
    }

    &:after {
        content: '';
        width: 20px;
        height: 20px;
        display: inline-block;
        position: absolute;
        margin-left: ${({ $gap }) => ($gap ? $gap - 20 : -20)}px;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
        left: -6px;
        border-radius: 50%;
        box-sizing: border-box;
        border: 1px solid ${theme.colors.ultraLightGrayFontColor};
        background-color: ${theme.colors.ultraLightGrayBorder};
    }

    ${({ $checked }) =>
        $checked &&
        css`
            color: ${theme.colors.blackColor};
            &:before {
                /* -webkit-transform: rotate(-45deg);
                -moz-transform: rotate(-45deg);
                -ms-transform: rotate(-45deg);
                -o-transform: rotate(-45deg);
                transform: rotate(-45deg); */
                border-bottom-style: solid;
                border-left-style: solid;
                border-color: ${theme.colors.whiteColor};
            }

            &:after {
                border-color: ${theme.colors.positiveBlue};
                background-color: ${theme.colors.positiveBlue};
            }
        `}
    ${({ $square }) =>
        $square &&
        css`
            &:after {
                border-radius: 0;
            }
        `}
`;
const Input = styled.input`
    /* position: absolute;
    opacity: 0;
    height: auto;
    z-index: -1; */
    display: none;
`;
